// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"39f91d2c","259":"bff6c7d1","354":"c7783229","762":"c7783229"}[chunkId] + ".chunk.css";
};